import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e4a715"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booking-menu-page" }
const _hoisted_2 = {
  key: 0,
  class: "filtered-wrapper flex justify-content-between gap-1 w-full overflow-auto pb-3"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "line-height-2 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "pi my-0 text-xs font-medium pi-times-circle absolute right-0 pr-2"
}
const _hoisted_6 = {
  key: 1,
  class: "filtered-wrapper flex align-items-baseline gap-1 w-auto overflow-x-scroll text-black pb-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs white-space-nowrap" }, "選択結果：", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pi m-0 text-xs pi-times-circle" }, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "flex w-full justify-content-start align-items-end text-sm border-bottom"
}
const _hoisted_11 = { class: "py-1 px-3 border-round-top-lg text-xs selected-tab-panel" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 h-full border-bottom-3" }, null, -1))
const _hoisted_13 = { class: "card-wrapper gap-3" }
const _hoisted_14 = {
  key: 0,
  class: "w-full pt-1 text-xs font-medium"
}
const _hoisted_15 = {
  key: 1,
  class: "w-full pt-1 text-xs font-medium"
}
const _hoisted_16 = { class: "card-header-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "pr-2 w-3"
}
const _hoisted_18 = {
  key: 0,
  class: "card-header-wrapper justify-content-start grid grid-nogutter"
}
const _hoisted_19 = { class: "card-header-wrapper justify-content-start align-items-center mt-2" }
const _hoisted_20 = { class: "title-3 header-name h-full text-105rem" }
const _hoisted_21 = { class: "card-header-wrapper justify-content-end align-items-baseline mt-3" }
const _hoisted_22 = { class: "title-3" }
const _hoisted_23 = { class: "title-3 ml-2 text-red-400 text-base font-bold" }
const _hoisted_24 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_25 = {
  key: 0,
  class: "readmore-btn-wrap align-content-end w-full flex justify-content-center flex-wrap text-xs"
}
const _hoisted_26 = { class: "flex justify-content-end" }
const _hoisted_27 = {
  key: 3,
  class: "controller-wrapper"
}

import { onMounted, ref, computed } from "vue";
/**
 * Vuexストア
 * アプリケーション全体の状態管理に使用
 */
import { useStore } from "vuex";
/**
 * HTTPクライアント
 * APIリクエストに使用
 */
import axios from "axios";
/**
 * 数値フォーマットユーティリティ
 * 価格の表示形式を整形するために使用
 */
import NumberUtils from "@/clinic/utils/number-utils";
/**
 * ルーティングユーティリティ
 * 画面遷移の制御に使用
 */
import RouterUtils from "@/common/utils/router.util";
/**
 * ルーティング定数
 * 画面遷移先の定義に使用
 */
import RouterConstants from "../constants/router.constants";
/**
 * APIルーティング定数
 * APIエンドポイントの定義に使用
 */
import ApiRouterConstants from "../../common/constants/api.router.constants";
/**
 * 公開状態定数
 * メニューの表示制御に使用
 */
import { VISIBILITY_PUBLIC_STATUS } from "@/common/constants/medical.constants";
/**
 * HTMLコンテンツユーティリティ
 * テキストの行数カウントに使用
 */
import htmlContent from "@/common/utils/html.content";
/**
 * スタッフ割り当てサービス
 * スタッフの自動割り当てに使用
 */
import { StaffDistributionService } from "@/clinic/services";
/**
 * サービスタグサービス
 * サービスタグの取得に使用
 */
import { ServiceTagService } from "@/customer/services";
/**
 * フィルターダイアログコンポーネント
 * メニューフィルターの表示に使用
 */
import DialogFilterMenus from "@/customer/components/dialog/DialogFilterMenus.vue";
/**
 * タグ関連の定数
 * タグの種類とピン留め状態の定義に使用
 */
import { PIN_TYPE, TAG_TYPE } from "@/clinic/typings/constants/service_tag";
/**
 * 予約設定サービス
 * 予約設定の取得に使用
 */
import BookingSettingService from "@/customer/services/booking-setting.service";
/**
 * クリニックパートナー列挙型
 * クリニックのパートナー種別の定義に使用
 */
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * フィルタタグの種類を定義
 * すべて、絞り込み、ピン留めの3種類
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingMenu',
  setup(__props) {

/**
 * 予約メニュー画面コンポーネント
 * メニューの一覧表示、フィルタリング、選択を行う画面
 * メニューの表示、タグによるフィルタリング、メニュー選択機能を提供
 */

/**
 * Vueの基本機能
 * コンポーネントのライフサイクルとリアクティブな状態管理に使用
 */
const filteredTagTypes = {
  all: { type: "All", name: "すべて" },
  more: { type: "More", name: "絞り込む" },
  pinned: { type: "Pinned" },
};

/**
 * 予約メニューのリスト
 * @type {Ref<any[]>}
 */
const bookingMenus = ref([]);

/**
 * メニューコンテンツ要素のリスト
 * @type {Ref<any[]>}
 */
const menuContentElements = ref([]);

/**
 * Vuexストアインスタンス
 */
const store = useStore();

/**
 * 予約設定
 * @type {Ref<Record<string, any>>}
 */
const bookingSetting = ref<Record<string, any>>({});

/**
 * サービスタグのリスト
 * @type {Ref<any[]>}
 */
const serviceTags = ref([]);

/**
 * フィルタされたタグIDのリスト
 * @type {Ref<number[]>}
 */
const filteredTagIds = ref<number[]>([]);

/**
 * フィルターダイアログの表示状態
 * @type {Ref<boolean>}
 */
const showFilterDialog = ref(false);

/**
 * ローディング状態
 * @type {Ref<boolean>}
 */
const isLoading = ref(false);
/**
 * メニューコンテンツの行数をチェック
 * @param {number} index - チェックするメニューのインデックス
 * @returns {boolean} 5行以上ある場合はtrue
 */
const manyLines = index => {
  if (menuContentElements.value[index]) {
    // メニューコンテンツの行数が5行を超える場合はtrueを返す
    return htmlContent.countLines(menuContentElements.value[index]) > 5;
  } else {
    // メニューコンテンツが存在しない場合はfalseを返す
    return false;
  }
};

// フィルタされたタグを計算するコンピューテッドプロパティ
const filteredTags = computed(() =>
  // 選択されたタグIDに一致するものをフィルタリング
  serviceTags.value.filter(tag => filteredTagIds.value.includes(tag.id))
);

// ピン留めされたサービスタグを計算するコンピューテッドプロパティ
const pinnedServiceTags = computed(() =>
  // サービスタグの中から、ピン留めタイプに一致するものをフィルタリング
  serviceTags.value.filter(tag => tag.pin == PIN_TYPE.pinned)
);

// ピン留めされたフィルタタグを計算するコンピューテッドプロパティ
const pinnedFilteredTags = computed(() => [
  // "すべて"タグを追加
  filteredTagTypes.all,
  // ピン留めされたサービスタグをマッピングして追加
  ...pinnedServiceTags.value.map(tag => ({ ...tag, ...filteredTagTypes.pinned })),
  // "絞り込む"タグを追加
  filteredTagTypes.more,
]);

/**
 * フィルタされたメニューを計算
 * 選択されたタグに基づいてメニューをフィルタリング
 */
const filteredMenus = computed(() => {
  // タグが選択されていない場合はすべてのメニューを返す
  if (filteredTagIds.value.length == 0) return bookingMenus.value;

  // 選択されたタグIDに一致するメニューをフィルタリングして返す
  return bookingMenus.value.filter(menu => {
    // メニューに関連付けられたタグIDを取得
    const menuTagIds = menu.service_tags.map(tag => tag.id);
    // 選択されたタグIDのいずれかがメニューのタグIDに含まれている場合にtrueを返す
    return filteredTagIds.value.some(tagId => menuTagIds?.includes(tagId));
  });
});

/**
 * タグが選択されているかどうかを判定
 * @param {string} type - タグの種類
 * @param {number} [id] - タグのID
 * @returns {boolean} 選択状態
 */
const isSelected = (type: string, id?: number) => {
  if (type == filteredTagTypes.all.type) return filteredTagIds.value.length == 0;
  // "絞り込む"タグは常に未選択
  if (type == filteredTagTypes.more.type) return false;
  // ピン留めされたタグが選択されているかどうかを判定
  if (type == filteredTagTypes.pinned.type) return filteredTagIds.value.includes(id);
  // その他のタグが選択されているかどうかを判定
  return false;
};

/**
 * ピン留めされたフィルタをクリックした際の処理
 * @param {string} type - タグの種類
 * @param {number} [id] - タグのID
 */
const onPinnedFilter = (type: string, id?: number) => {
  if (type == filteredTagTypes.all.type) {
    filteredTagIds.value = []; // 選択されたタグIDをリセット
    return;
  }
  // "絞り込む"タグをクリックした場合
  if (type == filteredTagTypes.more.type) {
    showFilterDialog.value = !showFilterDialog.value; // フィルタダイアログの表示/非表示を切り替え
    return;
  }
  // ピン留めされたタグをクリックした場合
  if (type == filteredTagTypes.pinned.type) {
    // 既に選択されている場合は解除
    if (filteredTagIds.value.includes(id)) {
      filteredTagIds.value = filteredTagIds.value.filter(tagId => tagId !== id);
    } else {
      // 選択されていない場合は追加
      filteredTagIds.value.push(id);
    }
    return;
  }
};

/**
 * フィルタされたタグを削除
 * @param {number} id - 削除するタグのID
 */
const onRemoveFilteredTag = (id: number) => (filteredTagIds.value = filteredTagIds.value.filter(tagId => tagId !== id));

/**
 * ダイアログで選択されたタグIDを設定
 * @param {number[]} tagIds - 選択されたタグIDの配列
 */
const onDialogFilter = (tagIds: number[]) =>
  // ダイアログで選択されたタグIDをfilteredTagIdsに設定
  (filteredTagIds.value = tagIds);

/**
 * 「もっと見る」ボタンのクリックイベントを処理
 * @param {Event} event - クリックイベント
 * @param {number} index - メニューのインデックス
 */
const handleReadMore = (event, index) => {
  // イベントの伝播を停止
  event.stopPropagation();

  // 該当するメニューコンテンツ要素が存在する場合
  if (menuContentElements.value[index]) {
    // "readmore"クラスを削除して全文を表示
    menuContentElements.value[index].classList.remove("readmore");
  }

  // 「もっと見る」ボタンの親要素を非表示にする
  event.target.closest(".readmore-btn-wrap").style.visibility = "hidden";
};

/**
 * コンポーネントのマウント時の処理
 * 予約設定の読み込み、メニューのフィルタリング、サービスタグの取得を実行
 */
onMounted(async () => {
  // Vuexストアから予約設定を取得
  const { data: settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  if (settings?.value) {
    store.commit("bookingSetting/setBookingSetting", settings.value);
    bookingSetting.value = settings.value;
  }

  // メニューのフィルタリングを実行
  await handleFilterMenu();

  // パートナーがUnaffiliatedの場合、サービスタグを取得
  if (bookingSetting.value.partner === ClinicPartner.Unaffiliated) {
    await fetchServiceTags();
  }
});

/**
 * メニューをフィルタリング
 * @param {string} [filter_by] - フィルター条件
 */
const handleFilterMenu = async (filter_by?: string) => {
  isLoading.value = true;
  // メニューリクエストを送信してデータを取得
  const response = await sendMenuRequest(filter_by);

  // 取得したメニューを格納
  bookingMenus.value = response.data;
  isLoading.value = false;
};

/**
 * サービスタグを取得
 */
const fetchServiceTags = async () => {
  // サービスタグを取得するAPIを呼び出し、クリニックIDをパラメータとして渡す
  const { data } = await ServiceTagService.fetchServiceTag({
    clinic_id: store.getters["line_account/clinicId"],
  });
  // 取得したサービスタグをserviceTagsに格納
  serviceTags.value = data.value.service_tags;
};

/**
 * メニューに関連付けられた単一選択タグを取得
 * @param {any} menu - メニュー情報
 * @returns {any} 単一選択タグ
 */
const singleSelectedTag = menu => {
  // 単一選択タイプのタグを検索し、最初に見つかったものを返す
  const singleTag = menu.service_tags.find(tag => tag.selected_type == TAG_TYPE.single.value);
  return singleTag;
};

/**
 * メニューに関連付けられた複数選択タグを取得
 * @param {any} menu - メニュー情報
 * @returns {any[]} 複数選択タグの配列
 */
const multipleSelectedTag = menu => {
  // 複数選択タイプのタグをすべて検索し、配列として返す
  const multipleTag = menu.service_tags.filter(tag => tag.selected_type == TAG_TYPE.multiple.value);
  return multipleTag;
};

/**
 * メニューリクエストを送信
 * @param {string} [filter_by] - フィルター条件
 * @returns {Promise<any>} APIレスポンス
 */
const sendMenuRequest = (filter_by?: string) => {
  // スタッフIDを取得
  // 自動スタッフ割り当てが有効またはデフォルトスタッフを使用する場合はundefinedを設定
  const staffId =
    store.getters["bookingSetting/autoStaffDistribution"] || store.getters["booking/selectUseDefaultStaff"]
      ? undefined
      : store.getters["booking/selectedStaffId"];

  // APIリクエストを送信
  return axios.get(ApiRouterConstants.API_MENU, {
    params: {
      clinic_id: store.getters["line_account/clinicId"],
      staff_id: staffId,
      category_id:
        store.getters["booking/selectedMenuCategoryId"] == 0 ? null : store.getters["booking/selectedMenuCategoryId"],
      filter_by: filter_by || null,
      visibility: VISIBILITY_PUBLIC_STATUS,
    },
    headers: { Accept: "application/json" },
  });
};

/**
 * メニュー選択時の処理
 * @param {any} menu - 選択されたメニュー
 */
const handleClickMenu = async (menu: any) => {
  // パートナーがRipicleで、メニューの施術時間が0分以下の場合はアラートを表示して処理を中断する
  if (bookingSetting.value.partner === ClinicPartner.Ripicle && menu.time_unit <= 0) {
    alert("施術時間が0分のメニューは予約できません");
    return;
  }

  // 選択されたメニューをVuexストアに保存
  store.commit("booking/selectMenu", menu);

  // 自動スタッフ割り当てが有効で、パートナーがUnaffiliatedの場合
  if (
    (store.getters["bookingSetting/autoStaffDistribution"] || store.getters["booking/selectUseDefaultStaff"]) &&
    bookingSetting.value.partner == ClinicPartner.Unaffiliated
  ) {
    // スタッフ割り当てサービスを呼び出してスタッフを取得
    const { data } = await StaffDistributionService.getStaff({
      clinic_id: store.getters["line_account/clinicId"],
      medical_menu_id: menu.id,
    });

    // 割り当てられたスタッフIDを取得
    const distributedStaffIds = data.value as unknown as number[];

    // 割り当てられたスタッフが現在選択されているスタッフと異なる場合、Vuexストアを更新
    if (distributedStaffIds[0] != store.getters["booking/selectedStaffId"]) {
      store.commit("booking/setAutoStaffDistributionData", distributedStaffIds);
      store.commit("bookingSetting/setAutoStaffDistribution", true);
    }
  }

  // bookingSettingの値を取得して設定
  const { data: settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  store.commit("bookingSetting/setBookingSetting", settings.value);

  // オプションの有無を確認
  const res = await axios.get(ApiRouterConstants.API_MENU_OPTION, {
    params: {
      clinic_id: store.getters["line_account/clinicId"],
      menu_id: menu.id,
    },
    headers: { Accept: "application/json" },
  });

  if (res.data && res.data.length > 0) {
    // オプションがある場合は、オプション選択画面に遷移
    RouterUtils.goTo(RouterConstants.BOOKING_OPTION_ROUTER_NAME);
  } else {
    // オプションがない場合は、スタッフ選択画面に遷移
    RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, { from: "menu" });
  }
};

/**
 * メニューの価格をフォーマット
 * @param {any} menu - メニュー情報
 * @returns {string} フォーマットされた価格
 */
const menuPrice = menu => (menu.display_price ? NumberUtils.formatJPCurrency(menu.unit_price) : "");

/**
 * 戻るボタンの処理
 * パートナーに応じて遷移先を変更
 */
const back = () => {
  if (store.getters["bookingSetting/partner"] == ClinicPartner.Ripicle) {
    // Ripicle連携店舗の場合、スタッフ一覧に戻る
    RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, {
      clinic_id: store.getters["line_account/clinicId"],
    });
  } else {
    // クエリパラメータを付けてメニューカテゴリ画面に遷移
    RouterUtils.goToWithQuery(RouterConstants.BOOKING_MENU_CATEGORY_ROUTER_NAME, {
      clinic_id: store.getters["line_account/clinicId"],
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (bookingSetting.value.partner == _unref(ClinicPartner).Unaffiliated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pinnedFilteredTags), (tag, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass([
          'w-full flex justify-content-center align-items-center border-round-md text-xs gap-2 py-1 font-medium text-black bg-pinned relative',
        ]),
              style: { whiteSpace: 'pre-line', minHeight: '2rem' },
              onClick: ($event: any) => (onPinnedFilter(tag.type, tag.id))
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(tag.name), 1),
              (tag.type != filteredTagTypes.more.type && isSelected(tag.type, tag.id))
                ? (_openBlock(), _createElementBlock("p", _hoisted_5))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(filteredTags).length > 0 && bookingSetting.value.partner == _unref(ClinicPartner).Unaffiliated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTags), (tag, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "w-max flex justify-content-center align-items-center border-round-xl gray-border py-1 px-2 text-xs font-bold gap-1 white-space-nowrap",
              onClick: ($event: any) => (onRemoveFilteredTag(tag.id))
            }, [
              _createTextVNode(_toDisplayString(tag.name) + " ", 1),
              _hoisted_9
            ], 8, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (filteredTagIds.value.length > 0 && bookingSetting.value.partner == _unref(ClinicPartner).Unaffiliated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, "結果: " + _toDisplayString(_unref(filteredMenus).length), 1),
          _hoisted_12
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "読み込み中..."))
        : (_unref(filteredMenus).length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "データがありません"))
          : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredMenus), (bookingMenu, index) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: bookingMenu,
          class: _normalizeClass({ 'p-card-selected': bookingMenu.id == _unref(store).getters['booking/selectedMenu'].id })
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              (bookingMenu.image_thumb_url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_Avatar, {
                      class: "h-full w-full",
                      image: bookingMenu.image_thumb_url
                    }, null, 8, ["image"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(bookingMenu.image_thumb_url ? 'w-9' : 'w-full')
              }, [
                (multipleSelectedTag(bookingMenu).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(multipleSelectedTag(bookingMenu), (tag) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "px-2 mr-1 mb-2 border-round-sm text-center text-white font-medium text-0.6 p-0125rem",
                          key: tag.id,
                          style: _normalizeStyle([{ 'background-color': tag.color }])
                        }, _toDisplayString(tag.name), 5))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  (singleSelectedTag(bookingMenu))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle([{ 'background-color': singleSelectedTag(bookingMenu)?.color }, 'white-space: pre']),
                        class: "text-center flex-shrink-0 px-2 mr-2 border-round-lg text-center text-white text-xs font-medium p-0125rem"
                      }, _toDisplayString(singleSelectedTag(bookingMenu)?.name), 5))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(bookingMenu.name), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(bookingMenu.time_unit != 0 ? bookingMenu.time_unit + "分" : ""), 1),
                  _createElementVNode("span", _hoisted_23, [
                    _createTextVNode(_toDisplayString(menuPrice(bookingMenu)) + " ", 1),
                    (bookingMenu.display_price)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "(税込)"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("p", {
              ref_for: true,
              ref: el => (menuContentElements.value[index] = el),
              class: _normalizeClass(["mb-4 text-xs", { readmore: manyLines(index) }])
            }, _toDisplayString(bookingMenu.description), 3),
            (manyLines(index))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_Button, {
                    class: "readmore-btn",
                    onClick: ($event: any) => (handleReadMore($event, index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("もっと見る")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Button, {
                class: "accept-btn",
                label: "選択",
                onClick: ($event: any) => (handleClickMenu(bookingMenu))
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ]),
    (bookingSetting.value.partner !== _unref(ClinicPartner).Ripicle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_Button, {
            class: "btn cancel-btn",
            onClick: back
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(DialogFilterMenus, {
      "filter-tag-ids": filteredTagIds.value,
      "service-tags": serviceTags.value,
      visible: showFilterDialog.value,
      onFilter: onDialogFilter
    }, null, 8, ["filter-tag-ids", "service-tags", "visible"])
  ]))
}
}

})